// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { SmsTokenDTO } from "../../../../../../../io/hyperify/core/auth/sms/types/SmsTokenDTO";
import { MY_LOGIN_ARTICLE_CLASS_NAME } from "../../../../../core/constants/className";
import { useState } from "react";
import { EmailTokenDTO } from "../../../../../../../io/hyperify/core/auth/email/types/EmailTokenDTO";
import { MyRequestCodeArticle } from "./MyRequestCodeArticle";
import { MyRequestEmailArticle } from "./MyRequestEmailArticle";
import { TranslationParams } from "../../../../../../../io/hyperify/core/types/TranslationParams";
import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";
import { MyRequestSmsArticle } from "./MyRequestSmsArticle";
import "./MyLoginArticle.scss";

export interface MyLoginArticleProps {
    readonly className?: string;
    readonly t: TranslationFunction;
    readonly translationParams?: TranslationParams;
    readonly title: string;
    readonly contentText: string;
    readonly submitButtonLabel?: string;
    readonly requestCodeTitle: string;
    readonly requestCodeText: string;
}

export function MyLoginArticle (props: MyLoginArticleProps) {
    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const className = props?.className;
    const title = props?.title;
    const contentText = props?.contentText;
    const submitButtonLabel = props?.submitButtonLabel;
    const requestCodeTitle = props?.requestCodeTitle;
    const requestCodeText = props?.requestCodeText;
    const translationParams = props?.translationParams;
    const [ token, setToken ] = useState<EmailTokenDTO | SmsTokenDTO | undefined>( undefined ); // FIXME: We could create a delayed state, which will reset to false after a while

    const [ authType, setAuthType ] = useState<string>( 'email' );

    return (
        token ? (
            <MyRequestCodeArticle
                t={t}
                translationParams={translationParams}
                className={MY_LOGIN_ARTICLE_CLASS_NAME + (className ? ' ' + className : '')}
                token={token}
                disableRequestCode={() => setToken( undefined )}
                title={requestCodeTitle}
                contentText={requestCodeText}
            />
        ) : (
            authType === 'sms'
                ? (
                    <MyRequestSmsArticle
                        t={t}
                        translationParams={translationParams}
                        className={MY_LOGIN_ARTICLE_CLASS_NAME + (className ? ' ' + className : '')}
                        enableRequestCode={(token: SmsTokenDTO) => setToken( token )}
                        title={title}
                        contentText={contentText}
                        submitButtonLabel={submitButtonLabel}
                        alternativeClick={() => setAuthType('email')}
                    />
                ) : (
                    <MyRequestEmailArticle
                        t={t}
                        translationParams={translationParams}
                        className={MY_LOGIN_ARTICLE_CLASS_NAME + (className ? ' ' + className : '')}
                        enableRequestCode={(token: EmailTokenDTO) => setToken( token )}
                        title={title}
                        contentText={contentText}
                        submitButtonLabel={submitButtonLabel}
                        alternativeClick={() => setAuthType('sms')}
                    />
                )
        )
    );
}
